import request, { gql } from "graphql-request";
import { GRAPHQL_API, GRAPHQL_MUTATION_TOKEN } from "../helpers";

export const submitFormMutation = async (formData) => {
  const {
    name: sendername,
    email: senderemail,
    message: sendermessage,
    formName: formname,
    pageUrl: pageurl,
    companyName: companyname,
    hcpsTargeting: hcpstargeting,
    billingCodeTargeting: billingcodetargeting,
    scheduleACall: scheduleacall,
    sendInformation: sendinformation,
    sendSampleLeadReport: sendsampleleadreport,
  } = formData;

  const query = gql`
    mutation SubmitContactUsForm(
      $sendername: String
      $senderemail: String!
      $sendermessage: String
      $receivedtimestamp: DateTime
      $formname: String
      $pageurl: String
      $companyname: String
      $hcpstargeting: String
      $billingcodetargeting: String
      $scheduleacall: Boolean
      $sendinformation: Boolean
      $sendsampleleadreport: Boolean
    ) {
      createFormSubmission(
        data: {
          sendername: $sendername
          senderemail: $senderemail
          sendermessage: $sendermessage
          receivedtimestamp: $receivedtimestamp
          formname: $formname
          pageurl: $pageurl
          companyname: $companyname
          hcpstargeting: $hcpstargeting
          billingcodetargeting: $billingcodetargeting
          scheduleacall: $scheduleacall
          sendinformation: $sendinformation
          sendsampleleadreport: $sendsampleleadreport
        }
      ) {
        id
      }
    }
  `;

  const result = await request(
    GRAPHQL_API,
    query,
    {
      sendername,
      senderemail,
      sendermessage,
      receivedtimestamp: new Date().toISOString(),
      formname,
      pageurl,
      companyname,
      hcpstargeting,
      billingcodetargeting,
      scheduleacall,
      sendinformation,
      sendsampleleadreport,
    },
    {
      Authorization: `Bearer ${GRAPHQL_MUTATION_TOKEN}`,
    }
  );

  return result?.createFormSubmission || null;
};
